import { TableFormik } from "./TableFormik";
import { CCLTableFormik } from "./CCLTableFormik";
import { TextBox } from "./TextBox";
import { SingleDropDown } from "./SingleDropDown";
import { Fibre } from "./Fibre";
import { ImageList } from "./ImageList";
import { StaticImage } from "./StaticImage";
import { Checkbox } from "./Checkbox";
import { TextArea } from "./TextArea";
import { BarCode } from "./BarCode";
import ListBoxWidget from "./ListBoxWidget";
import { CatalogueTableFormik } from "./CatalogueTableFormik";
import { Label } from "./Label";
import { Txt } from "./Txt";
import MultiSelect from "./multiSelectLabel";
import { CommonLabel } from "./CommonLabel";
import CatalogueOutTableTextboxField from "./CatalogueOutTableTextboxField";
import CatalogueOutTableDropdownField from "./CatalogueOutTableDropdownField";
import CatalogueOutTableLabelField from "./CatalogueOutTableLabelField";
import { ELLDropDown } from "./ELLDropDown";
import { LLIDropDown } from "./LLIDropDown";
import { ELCSelectDropDown } from "./ELCSelectDropDown";
const FormElement = ({
  elementName,
  user,
  selectedOption,
  handleDropdownChange,
  setChildOpt,
  formData,
  csvData,
  uploaded,
  val,
  pageId,
  pageSequence,
  childPages,
  catTabData,
  catTabData2,
  tableItemID,
  resetELCList,
  ELLValue,
  ELLSchemaItem,
  setFormData,
  setPageChange,
  pageChange,
  mandatoryByLabelName,
  disableByLabelName,
  mapTableItemID,
  csvUplaodEnabled,
  setCatTabData,
  setCatTabData2,
  handleResetELCList,
  handleELLValue,
  searchParams,
  divisionID,
  ELCDropDown,
  setELCDropDown,
  setIsLoading,
  childOpt,
  setLLIValue,
  LLIValue,
  toggleTescoFileUploaded,
  user_id,
  allow100PercentFibreWithourGarment,
  SetcatalogueChildOptn,
  catalogueChildOptn,
  store_grp,
  handleELLVSchemaItem,
  ediReadonlyMode,
  ediEditableFields,
  factoryDivisionConfig,
  copySecondarySizeEnabled,
}) => {
  let props = {
    schemaType: elementName.schemaType,
    catalogueSchemaType: elementName.catalogueSchemaType,
    keyValues: elementName.keyValues,
    name: elementName.fieldName,
    label: elementName.fieldName,
    options: elementName.options,
    child1: elementName.Child,
    tagName: elementName.tagName,
    prefix: elementName.prefix,
    Lines:
      csvData !== undefined
        ? csvData?.data?.length
        : user[elementName.fieldName]
        ? user[elementName.fieldName].length
        : elementName.numberOfLinesToDisplay,
    value: elementName.value,
    dataType: elementName.dataType,
    validation: {
      mandatory: elementName.validation?.mandatory,
      maxLength: elementName.validation?.maxLength,
      minLength: elementName.validation?.minLength,
      rules: elementName.validation?.rules,
      pictureMask: elementName.validation?.pictureMask,
      characterCase: elementName.validation?.characterCase,
      LableTableMapPart: elementName.validation?.LableTableMapPart,
      disableByLabelName: elementName.validation?.disableByLabelName,
      mandatoryByLabelName: elementName.validation?.mandatoryByLabelName,
      mandatoryGarmentPart: elementName.validation?.mandatoryGarmentPart,
      componentMinMax: elementName.validation?.componentMinMax,
    },
    MinimumGridLines: elementName.MinimumGridLines,
    ColumnDefinition: elementName.ColumnDefinition,
    RowDefinition: elementName.RowDefinition,
    MoreRows: elementName.MoreRows,
    schemaPageFields: elementName.schemaPageSubItems,
    Skudetails: elementName.schemaPageFields,
    maxNoLines: elementName.maxNoLines,
    schemaPageId: pageId,
    schemaResult: val,
    itemId: elementName.itemId,
    schemaItem: elementName.schemaItem,
    orientation: elementName.orientation,
    headerList: elementName.headerList,
    category: elementName.category,
    imageId: elementName.imageId,
    type: elementName.type,
    calculation: elementName.calculation,
    size: elementName.size,
    careControls: elementName.careControls,
    childLists: elementName.childLists,
    childPageId: elementName.childPageId,
    childItemId: elementName.childItemId,
    showAlias: elementName.showAlias,
    pageSequence: pageSequence,
    childPages: childPages,
    display: elementName.display,
    keyIndex: elementName.keyIndex,
    lastKey: elementName.lastKey,
    wastage: false,
    labelReference: elementName.labelReference,
    csvUpload: uploaded,
    mandatoryByLabelName: mandatoryByLabelName,
    disableByLabelName: disableByLabelName,
    imagePreviewRequired: elementName.imagePreviewRequired,
    catId: elementName.catId,
    SetcatalogueChildOptn: SetcatalogueChildOptn,
    catalogueChildOptn: catalogueChildOptn,
    store_grp: store_grp,
    user_id: user_id,
    divisionID: divisionID,
    ediReadonlyMode: ediReadonlyMode,
    ediEditableFields: ediReadonlyMode ? ediEditableFields : undefined,
    factoryDivisionConfig: factoryDivisionConfig,
    copySecondarySizeEnabled: copySecondarySizeEnabled,
  };

  switch (elementName.prefix) {
    case "QTY":
      return <TextBox value={user[elementName.fieldName]} {...props} />;
    case "TXT":
      return <Txt {...props} />;
    case "MLT":
      return <TextArea {...props} />;
    case "SLI":
      props = {
        ...props,
        setChildOpt,
        formData,
        csvData,
        childOpt,
        setLLIValue,
        LLIValue,
      };
      return (
        <SingleDropDown
          value={user[elementName.fieldName]}
          {...props}
          handleResetELCList={handleResetELCList}
          handleELLValue={handleELLValue}
        />
      );
    case "ELL":
      props = {
        ...props,
        setChildOpt,
        formData,
        csvData,
        childOpt,
        setLLIValue,
        LLIValue,
      };
      return (
        <ELLDropDown
          value={user[elementName.fieldName]}
          {...props}
          handleResetELCList={handleResetELCList}
          handleELLValue={handleELLValue}
          handleELLVSchemaItem={handleELLVSchemaItem}
        />
      );
    case "ELC":
      props = {
        ...props,
        setChildOpt,
        formData,
        csvData,
        childOpt,
        setLLIValue,
        LLIValue,
      };
      return (
        <ELCSelectDropDown
          value={user[elementName.fieldName]}
          {...props}
          handleResetELCList={handleResetELCList}
          handleELLValue={handleELLValue}
          ELLValue={ELLValue}
          elementName={elementName}
        />
      );
    case "LLI":
      props = {
        ...props,
        setChildOpt,
        formData,
        csvData,
        childOpt,
        setLLIValue,
        LLIValue,
      };
      return (
        <LLIDropDown
          value={user[elementName.fieldName]}
          {...props}
          handleResetELCList={handleResetELCList}
          handleELLValue={handleELLValue}
        />
      );
    case "STI":
      return <StaticImage {...props} />;
    case "ILI":
      return <ImageList value={user[elementName.fieldName]} {...props} />;
    case "LAB":
      if (!elementName.multiSelect) {
        return (
          <Label
            selectedOption={selectedOption}
            handleDropdownChange={handleDropdownChange}
            value={user[elementName.fieldName]}
            showImage={elementName.showImage}
            user_id={user_id}
            {...props}
          />
        );
      } else if (elementName.multiSelect) {
        return (
          <MultiSelect
            {...props}
            showImage={elementName.showImage}
            user_id={user_id}
          />
        );
      }
    case "TAB":
      if (
        mapTableItemID?.includes(elementName.itemId?.toString()) &&
        selectedOption !== "" &&
        selectedOption !== null &&
        tableItemID?.includes(elementName.itemId?.toString())
      ) {
        return (
          <TableFormik
            {...props}
            setChildOpt={setChildOpt}
            setCatTabData={setCatTabData}
            setCatTabData2={setCatTabData2}
            formData={formData}
            csvUplaodEnabled={csvUplaodEnabled}
            resetELCList={resetELCList}
            ELLValue={ELLValue}
            setFormData={setFormData}
            setPageChange={setPageChange}
            pageChange={pageChange}
            searchParams={searchParams}
            divisionID={divisionID}
            ELCDropDown={ELCDropDown}
            setELCDropDown={setELCDropDown}
            setIsLoading={setIsLoading}
            toggleTescoFileUploaded={toggleTescoFileUploaded}
            SetcatalogueChildOptn={SetcatalogueChildOptn}
            catalogueChildOptn={catalogueChildOptn}
            user_id={user_id}
            store_grp={store_grp}
            childOpt={childOpt}
          />
        );
      } else if (!tableItemID?.includes(elementName.itemId?.toString())) {
        return (
          <TableFormik
            {...props}
            setChildOpt={setChildOpt}
            setCatTabData={setCatTabData}
            setCatTabData2={setCatTabData2}
            formData={formData}
            csvUplaodEnabled={csvUplaodEnabled}
            resetELCList={resetELCList}
            ELLValue={ELLValue}
            ELLSchemaItem={ELLSchemaItem}
            handleResetELCList={handleResetELCList}
            handleELLValue={handleELLValue}
            setFormData={setFormData}
            setPageChange={setPageChange}
            pageChange={pageChange}
            searchParams={searchParams}
            divisionID={divisionID}
            ELCDropDown={ELCDropDown}
            setELCDropDown={setELCDropDown}
            setIsLoading={setIsLoading}
            toggleTescoFileUploaded={toggleTescoFileUploaded}
            SetcatalogueChildOptn={SetcatalogueChildOptn}
            catalogueChildOptn={catalogueChildOptn}
            user_id={user_id}
            store_grp={store_grp}
            childOpt={childOpt}
            handleELLVSchemaItem={handleELLVSchemaItem}
          />
        );
      } else {
        return;
      }

    case "CTB":
      props.catTabData = catalogueChildOptn || catTabData;
      props.tableData = user[elementName.fieldName] ?? [];
      return (
        <CatalogueTableFormik
          {...props}
          user_id={user_id}
          store_grp={store_grp}
        />
      );
    case "CCL":
      return <CCLTableFormik {...props} />;
    case "CHK":
      return <Checkbox {...props} />;
    case "BAR":
      return <BarCode {...props} />;
    case "LIB":
      return (
        <div>
          <ListBoxWidget
            {...props}
            firstList={elementName.options}
            secondList={user[elementName.fieldName] || []}
          />
        </div>
      );
    case "STC":
      return <CommonLabel value={user[elementName.fieldName]} {...props} />;
    case "FIB":
      return (
        <Fibre
          {...props}
          allow100PercentFibreWithourGarment={
            allow100PercentFibreWithourGarment
          }
        />
      );
    case "CAT":
      if (elementName.catalogueSchemaType === 3) {
        return (
          <CatalogueOutTableDropdownField
            {...props}
            SetcatalogueChildOptn={SetcatalogueChildOptn}
            user_id={user_id}
            store_grp={store_grp}
          />
        );
      }
      if (elementName.catalogueSchemaType === 7) {
        return (
          <CatalogueOutTableLabelField
            {...props}
          />
        );
      }
      return (
        <CatalogueOutTableTextboxField
          {...props}
          SetcatalogueChildOptn={SetcatalogueChildOptn}
          user_id={user_id}
          store_grp={store_grp}
        />
      );
    default:
      return null;
  }
};

export default FormElement;
